import { RealtimeAgent } from "@openai/agents/realtime";
import { calcomTools, informationTools } from "../tools/tools";
import type { Tool } from "@openai/agents";
import {
  createInfomationCollectAgentPrompt,
  createMeetingBookerPrompt,
} from "./prompt";
import type { ContextV1, WorkflowV1 } from "@callcow/core";

function gatherTools(workflow: WorkflowV1) {
  if (typeof window !== "undefined") {
    return [];
  }

  const tools: Tool[] = [];
  if (workflow.tools.includes("schedule_calcom")) {
    tools.push(...calcomTools);
  }

  tools.push(...informationTools);
  return tools;
}

function createMeetingBookerAgent({
  workflow,
  context,
}: {
  workflow: WorkflowV1;
  context: ContextV1;
}) {
  if (workflow.type !== "schedule-meetings")
    throw new Error(
      "createMeetingBookerAgent called with type that is not |schedule-meetings|"
    );

  return new RealtimeAgent({
    name: workflow.type,
    voice: workflow.voice,
    handoffDescription:
      "handoff in the case the agent likes to speak with a human",
    instructions: createMeetingBookerPrompt({ workflow, context }),
    tools: gatherTools(workflow),
    handoffs: [],
  });
}

function createCollectInfoAgent({
  workflow,
  context,
}: {
  workflow: WorkflowV1;
  context: ContextV1;
}) {
  if (workflow.type !== "collect-info")
    throw new Error(
      "createCollectInfoAgent called with type that is not |collect-info|"
    );

  return new RealtimeAgent({
    name: workflow.type,
    voice: workflow.voice,
    handoffDescription:
      "handoff in the case the agent likes to speak with a human",
    instructions: createInfomationCollectAgentPrompt({ workflow, context }),
    tools: gatherTools(workflow),
    handoffs: [],
  });
}

export function createAgent({
  workflow,
  context,
}: {
  workflow: WorkflowV1;
  context: ContextV1;
}): RealtimeAgent {
  console.log("createAgent " + workflow.type);
  switch (workflow.type) {
    case "collect-info":
      return createCollectInfoAgent({ workflow, context });
    case "schedule-meetings":
      return createMeetingBookerAgent({ workflow, context });
  }
}
